import React, { Component } from "react";
import { Form, Header, Icon, Segment } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import UserInput from "../UserInput";

class XentrySettingsConfiguration extends Component {
  handleInputChange = e => {
    const { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [e.target.name]: e.target.value });
  };

  render() {
    const { location, t } = this.props;

    return (
      <Segment>
        <Header as="h5">
          <Icon name="wrench" />
          <Header.Content>{t("xentry_configuration").message || "Xentry configuration"}</Header.Content>
        </Header>
        <Form>
          <Form.Field className="full-width-input">
            <label>{t("xentry_sub_outlet_id").message || "Xentry sub outlet ID"}</label>
            <UserInput
              value={location.xentry_sub_outlet_id}
              name="xentry_sub_outlet_id"
              placeholder={t("xentry_sub_outlet_id").message || "Xentry sub outlet ID"}
              onChange={this.handleInputChange}
            />
          </Form.Field>
        </Form>
      </Segment>
    );
  }
}

export default withTranslation()(XentrySettingsConfiguration);
